module.exports = __webpack_public_path__ + "media/images/img_linePC-7eff186c7f75a710669378e3d275c20b.jpg";